import {ALLOWED_NON_TOKEN_COLORS} from './_constants';

const outlineTransformer = (v: string) => `1px solid ${v}`;

export const interactivity = {
  appearance: {
    scale: true,
  },
  cursor: {
    scale: true,
  },
  outline: {
    scale: 'colors',
    transform: outlineTransformer,
  },
  outlineColor: {
    scale: 'colors',
    strictView: true,
    includes: ALLOWED_NON_TOKEN_COLORS,
  },
  outlineOffset: {
    scale: 'space',
  },
  outlineWidth: {
    scale: 'space',
  },
  pointerEvents: {
    scale: true,
  },
  resize: {
    scale: true,
  },
  userSelect: {
    scale: true,
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Interactivity = typeof interactivity;
